__turbopack_context__.v({
  "productListItem": "styles-module__2wDP6G__productListItem",
  "searchTerm": "styles-module__2wDP6G__searchTerm",
  "seeMoreText": "styles-module__2wDP6G__seeMoreText",
});
